import { ChangeDetectionStrategy, Component, input } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { DefaultFormValueControl } from '@coin/shared/core/util-helpers';
import { CardPadding, CardRounding, V2CardComponent } from '../card/v2-card.component';
import { V2CheckboxComponent } from '../checkbox/v2-checkbox.component';

@Component({
  selector: 'coin-v2-selectable-card',
  templateUrl: './v2-selectable-card.component.html',
  styleUrls: ['./v2-selectable-card.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [V2CardComponent, V2CheckboxComponent, FormsModule],
  host: {
    '[class]': "`${this.disabled() ? 'disabled' : ''}`"
  }
})
export class V2SelectableCardComponent extends DefaultFormValueControl<boolean> {
  readonly padding = input<CardPadding>('medium');
  readonly rounding = input<CardRounding>('medium');

  protected toggleCard(): void {
    if (this.disabled()) return;
    this.updateValue(!this.viewValue());
  }
}
